import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import CustomModal from '../customModal';
import Scrollbars from '../scrollbars';
import RichTextPreview from '../richTextPreview';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  paper: {
    boxSizing: 'border-box',
    width: 850,
    height: 472,
  },
  root: {
    boxSizing: 'border-box',
    borderTop: `1px solid ${primary.bluish5}`,
    display: 'flex',
    width: '100%',
    minHeight: 0,
    position: 'relative',
    paddingTop: spacing(9),
    '&::before': {
      backgroundColor: primary.bluish5,
      content: '""',
      position: 'absolute',
      top: -1,
      left: -32,
      width: 32,
      height: 1,
    },
    '&::after': {
      backgroundColor: primary.bluish5,
      content: '""',
      position: 'absolute',
      top: -1,
      right: -32,
      width: 32,
      height: 1,
    },
  },
  scrollWrapper: {
    width: '100%',
    minHeight: 0,
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  description: {
    width: 640,
  },
  scrollY: {
    right: -19,
  },
}));

const PreviewDescriptionDialog = ({
  title,
  description = '',
  isOpened,
  onClose,
}) => {
  const classes = useStyles();

  return (
    <CustomModal
      paperClass={classes.paper}
      isOpened={isOpened}
      title={title}
      onClose={onClose}
      shouldRemoveFooter
    >
      <div className={classes.root}>
        <div className={classes.scrollWrapper}>
          <Scrollbars verticalScrollClass={classes.scrollY}>
            <div className={classes.content}>
              <RichTextPreview
                className={classes.description}
                text={description}
              />
            </div>
          </Scrollbars>
        </div>
      </div>
    </CustomModal>
  );
};

PreviewDescriptionDialog.propTypes = {
  title: PropTypes.string.isRequired,
  isOpened: PropTypes.bool.isRequired,
  description: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default PreviewDescriptionDialog;
